import { ReactiveMap } from "@solid-primitives/map";
import type { IDBPDatabase } from "idb";
import type { Relationship } from "sdk";
import { batch } from "solid-js";
import type { ApiDB } from "@/lib/sync/db";
import { BaseService } from "../core/Service";
import type { RootStore } from "../core/Store";

type UserId = string;

export class RelationshipsService extends BaseService<Relationship> {
	cache: ReactiveMap<UserId, Relationship> = new ReactiveMap();

	constructor(
		private store: RootStore,
		private getDb?: () => IDBPDatabase<ApiDB> | undefined,
	) {
		super(store, getDb);
	}

	clear() {
		this.cache.clear();
	}

	get(user_id: UserId) {
		return this.cache.get(user_id);
	}

	upsert() {
		throw new Error("Cannot upsert relationship without user id.");
	}

	upsertRelationship(user_id: UserId, relationship: Relationship) {
		this.cache.set(user_id, relationship);
		// TODO: upsert this.db
	}

	delete(user_id: UserId) {
		this.cache.delete(user_id);
	}

	get relationships() {
		return [...this.cache.entries()];
	}

	async accept(target_id: UserId) {
		await this.store.client.http.PUT("/api/v1/user/@self/friend/{target_id}", {
			params: { path: { target_id } },
		});
	}

	async reject(target_id: UserId) {
		await this.store.client.http.DELETE(
			"/api/v1/user/@self/friend/{target_id}",
			{
				params: { path: { target_id } },
			},
		);
	}

	// NOTE: merge with accept()?
	async send(target_id: UserId) {
		await this.store.client.http.PUT("/api/v1/user/@self/friend/{target_id}", {
			params: { path: { target_id } },
		});
	}
}
